module.exports = __webpack_public_path__ + "img/partner6.43d4fed1.png";